export default {
  data() {
    return {
      mode: 'edit'
    };
  },
  provide() {
    return {
      mode: () => this.mode
    };
  },
  computed: {
    isEdit() {
      return this.mode === 'edit';
    },
    isRead() {
      return this.mode === 'read';
    }
  }
};
